import React, { useState} from "react";
import PaypalQrCode from "./Images/PaypalQrCode";
const Hire = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [capsLockCheck, setCapsLockCheck] = useState(false);

  const handleKeyDown = (event) => {
    const { key, keyCode } = event;

    if (key === 'CapsLock' || keyCode === 20) {
      setCapsLockCheck(true);
    }
  };
  
 return (

  <>

  <div className="wrapper">
  
  <div className="black-back"><p className="text text-background no-over">Thank you for taking the time to visit my portfolio, and for considering me for your project or position. I would be delighted to have the opportunity to with you and make a noticable impact on your business solutions!</p></div>

    <form className="hire-form" action="https://formsubmit.co/mvmclx@gmail.com" method="POST" >
<div className="form-head">
  <h2 className="left-text"> Availability : Open<PaypalQrCode/></h2>
  </div>
    
      <label className="form-label" for="name">
        Name  
        <input 
          type="text"
          name="name"
          value={name}
          required
          className="input-message"
          onChange={(e) => setName(e.target.value)}
        /><br/><span className="letter-b animated fadeInDown">{name}</span>
      </label>

      <div className="line"></div>
      <label className="form-label" for="email">
        Email
        <input 
          type="email"
          value={email}
          name="email"
          required
          className="input-message"
          onChange={(e) => setEmail(e.target.value)}
        /><br/><span className="letter-b animated fadeInDown">{email}</span>
      <div className="line"></div>
      <br/></label>
      <label className="form-label">
        Phone
        <input 
          type="text"
          value={phone}
          
          className="input-message"
          onChange={(e) => setPhone(e.target.value)}
        />
<br/><span className="letter-b animated fadeInDown">{phone}</span><br/></label>
<div className="line"></div>

<input type="hidden" name="_captcha" value="false"/>
        <input type="hidden" name="_subject" value="A New form submission from your portfolio!!"/>
      <br/>
    <label class="label-and-button form-label" for='message'>  
        Message
        

        <input
        name="message"
          value={message}
          className="input-messagebox"
          cols="100"
          type="text"
          required
          rows="10"
          onChange={(e) => setMessage(e.target.value)}
        />      <button type="submit" className="btn submit-btn form-label" >
        Submit

      </button> 
      <p className="out-text no-over">I'll talk to you soon!</p></label>
 <a href="/" className=" back-link">Back to home</a>
    </form>
   
    </div>
    
 </>
  )
}



export default Hire